/**
 * 预览子组件-一视前置预览组件
 * @author chenqunfeng
 * @since 17/11/06
 */

import './video-forward-view.less';

import React, { Component } from 'react';
import PropTypes from 'prop-types';

class PreviewForwardView extends Component {
  static propTypes = {
    data: PropTypes.object,
  };

  getEleImage() {
    const { elementsImage } = this.props.data;

    if (elementsImage) {
      return (
        <span>
          <span className="s-icon icon-picture" />
          <span className="s-preview-video-ele-image">
            {elementsImage || '--'}
          </span>
        </span>
      );
    }
    return null;
  }

  getEleText() {
    const { elementsText } = this.props.data;

    if (elementsText) {
      return (
        <span>
          <span className="s-icon icon-font" />
          <span className="s-preview-video-ele-text">
            {elementsText || '--'}
          </span>
        </span>
      );
    }
    return null;
  }

  getEleVideo() {
    const { elementsVideo } = this.props.data;

    if (elementsVideo) {
      return (
        <span>
          <span className="s-icon icon-video" />
          <span className="s-preview-video-ele-video">
            {elementsVideo || '--'}
          </span>
        </span>
      );
    }
    return null;
  }

  render() {
    const { desc, duration } = this.props.data;

    return (
      <div className="s-preview-video-forward-view">
        <div className="s-preview-video-desc">
          <div className="s-preview-video-desc-title">使用说明</div>
          <div className="s-preview-video-desc-content">{desc || '--'}</div>
        </div>
        <div className="s-preview-video-duration">
          <span className="s-preview-video-duration-title">时长：</span>
          <span className="s-preview-video-duration-content">
            {duration || '--'}秒
          </span>
        </div>
        <div className="s-preview-video-ele">
          <span className="s-preview-video-ele-title">可替换内容：</span>
          {this.getEleText()}
          {this.getEleImage()}
          {this.getEleVideo()}
        </div>
      </div>
    );
  }
}

export default PreviewForwardView;
